import { Container } from "../Container/container";
import "./profileModal.css";
import instagram from "../../images/instagram.png";
import whatsapp from "../../images/whatsapp.png";
import facebook from "../../images/facebook.png";

export const ProfileModal = ({ user, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal__content" onClick={(e) => e.stopPropagation()}>
        <button className="modal__close" onClick={onClose}>×</button>
        <h2>Profile</h2>
        <div className="profile__info">
          <p><strong>Name:</strong> {user.username}</p>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Password:</strong> {"●".repeat(user.password.length)}</p>
        </div>
        <div className="profile__contacts">
          <h3>Contacts</h3>
          <ul className="profile__block">
            <a><img src={instagram} alt="" /></a>
            <a><img src={whatsapp} alt="" /></a>
            <a><img src={facebook} alt="" /></a>
          </ul>
        </div>
      </div>
    </div>
  );
};